export const initRefData = {
  Ref1: false,
  Ref2: false
}